import { render, staticRenderFns } from "./CreerPays.vue?vue&type=template&id=2ba75688&scoped=true"
import script from "./CreerPays.vue?vue&type=script&lang=js"
export * from "./CreerPays.vue?vue&type=script&lang=js"
import style0 from "./CreerPays.vue?vue&type=style&index=0&id=2ba75688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba75688",
  null
  
)

export default component.exports